import { Collapse, Icon } from "@blueprintjs/core"
import { useToggle } from "@mantine/hooks"
import Divider from "components/Atoms/Divider"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import ColourSelector from "components/Organisms/ColourSelector"
import { COLOURS } from "data/static.items"
import { ROUTE_CATEGORIES } from "graphql/selector.queries.gql"
import { ALL_SURVEY_AREAS } from "graphql/survey-areas/survey-areas.queries.gql"
import useRouteStore from "pages/fsm/routes.store"
import React from "react"
import { useCurrentDcId } from "store/auth.redux"

type RouteInfoType = {
  isReadOnly?: boolean
}
const RouteInfo = ({ isReadOnly }: RouteInfoType) => {
  const [isOpen, toggle] = useToggle([true, false])

  const currentDcId = useCurrentDcId()
  const [data, setData] = useRouteStore(store => [store.data, store.setData])

  function getLabel(label: string) {
    return label
  }
  return (
    <div className="mt-1 cursor-pointer">
      <header onClick={() => toggle()} className="bg-white font-sm flex p-2">
        <Icon className="mr-2" icon={isOpen ? "chevron-up" : "chevron-down"} />{" "}
        <h6 className="my-0">Route details</h6>
      </header>
      <Collapse isOpen={isOpen}>
        <div id="fsm-route-details" className="p-2 bg-white">
          {isReadOnly ? (
            <>
              <div className="text-sm">
                <span
                  style={{
                    height: 10,
                    width: 10,
                    background: "green",
                  }}
                />{" "}
                {data.name || "---"} ({" "}
                {data.surveyArea?.properties?.name || "---"} )
              </div>
            </>
          ) : (
            <>
              <DynamicSelector
                path="surveyArea"
                onChange={setData}
                name="properties.name"
                label={getLabel("Survey Area")}
                inline
                value={data.surveyArea}
                query={ALL_SURVEY_AREAS}
                variables={{
                  filter: {
                    distributionCentreIds: [currentDcId],
                  },
                }}
              />
              <StringInput
                required
                path="name"
                onChange={setData}
                big={false}
                label={getLabel("Route Name")}
                inline
                value={data.name}
              />
              <DynamicSelector
                query={ROUTE_CATEGORIES}
                required
                path="category"
                onChange={setData}
                big={false}
                label={getLabel("Category")}
                inline
                value={data.category}
              />
              <ColourSelector
                onChange={setData}
                big={false}
                label={getLabel("Route Color")}
                inline
                items={COLOURS}
                value={data.colorCode}
              />
            </>
          )}
        </div>
        <Divider className="my-0" />
      </Collapse>
    </div>
  )
}

export default RouteInfo
